<template>
    <div style="width: 100%; background: #fff">
        <div v-for="(table, ti) of tables_" :key="ti">
            <div v-if="table.style && table.style.display && table.style.display === 'none'" />
            <div v-else>
                <div :class="{ 'd-flex': !row.repeat }" v-for="(row, ri) of table.rows" :key="ri">
                    <!-- row is repeat -->
                    <template v-if="row.repeat">
                        <div v-for="li in row.repeatMaxCount" :key="li" class="d-flex">
                            <div
                                class="d-flex align-center"
                                v-for="(col, ci) of row.columns"
                                :key="ri + '-' + li + '-' + ci"
                                :style="getStyle(col)"
                            >
                                <template
                                    v-if="
                                        col.component &&
                                        (col.component.includes('address') ||
                                            col.component.includes('financial'))
                                    "
                                >
                                    <TaxFormAddress
                                        :component="col.component"
                                        :fieldsChild="fieldsChild_"
                                        :subtype="col.component.subtype"
                                        :colKey="col.key"
                                        :isLoaded="isLoaded"
                                        :isSent="isSent"
                                        :readOnly="readOnly || isReadonly(col.key)"
                                        :millesimInput="millesim"
                                        @updateSpecManager="updateSpecManager()"
                                    />
                                </template>
                                <template v-else-if="isFormattedText(col.key)">
                                    <v-progress-circular
                                        v-if="!fieldsChild_[`${getRepeatedKey(col.key, li)}`]"
                                        indeterminate
                                        color="primary"
                                        size="20"
                                    />
                                    <TaxFormFormattedText
                                        v-else
                                        v-model="
                                            fieldsChild_[`${getRepeatedKey(col.key, li)}`]
                                                .displayValue
                                        "
                                        @updateSpecManager="updateSpecManager()"
                                    />
                                </template>
                                <template v-else-if="col.type && col.type === 'title'">
                                    {{ col.value }}
                                </template>
                                <template v-else-if="col.key && isLoaded">
                                    <v-row no-gutters class="pt-2">
                                        <v-col
                                            cols="12"
                                            v-if="!fieldsChild_[`${getRepeatedKey(col.key, li)}`]"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                color="primary"
                                                size="20"
                                            />
                                        </v-col>
                                        <v-col cols="12" v-else-if="selectorOfKey(col.key)">
                                            <template v-if="isCheckbox(selectorOfKey(col.key))">
                                                <v-checkbox
                                                    :readonly="isReadonly(col.key)"
                                                    v-model="
                                                        fieldsChild_[
                                                            `${getRepeatedKey(col.key, li)}`
                                                        ].displayValue
                                                    "
                                                    true-value="X"
                                                    :false-value="''"
                                                    hide-details
                                                    class="mt-0"
                                                    @update:model-value="
                                                        updateSpecManager();
                                                        // as a refresh key but very fast ...
                                                        // for example : 2035A:GF is a reactive value, function of 2035A:GG checkbox value, but is not reactive otherwise
                                                        dialog2 = true;
                                                        dialog2 = false;
                                                        //
                                                    "
                                                    color="primary"
                                                />
                                            </template>
                                            <template v-else>
                                                <v-select-filled
                                                    :readonly="isReadonly(col.key)"
                                                    v-model="
                                                        fieldsChild_[
                                                            `${getRepeatedKey(col.key, li)}`
                                                        ].displayValue
                                                    "
                                                    :items="
                                                        getSelectorValuesFile(
                                                            selectorOfKey(col.key),
                                                        )
                                                    "
                                                    :append-inner-icon="
                                                        fieldsChild_[
                                                            `${getRepeatedKey(col.key, li)}`
                                                        ].value
                                                            ? ''
                                                            : undefined
                                                    "
                                                    :bg-color="
                                                        isUserValue(col.key)
                                                            ? 'blue lighten-5'
                                                            : '#FFF'
                                                    "
                                                    hide-details
                                                    :class="{
                                                        'form-field': true,
                                                        'oss-dark': true,
                                                        'focus-form-field': isImpactedByRule(
                                                            col.key,
                                                        ),
                                                        'text-truncate': true,
                                                    }"
                                                    clearable
                                                    block
                                                    @update:focused="onFocus($event, col.key)"
                                                    @update:model-value="updateSpecManager()"
                                                    @click="setFocusedField(col.key)"
                                                    density="compact"
                                                    item-title="text"
                                                    item-value="value"
                                                >
                                                    <!-- <template v-slot:selection="{ item }">
                                                        <v-icon v-if="!item">$fa-caret-down</v-icon>
                                                        <span v-if="isSmallInput(col)">
                                                            {{ item.value }}
                                                        </span>
                                                        <span v-else>
                                                            {{ item.text }}
                                                        </span>
                                                    </template> -->
                                                </v-select-filled>
                                            </template>
                                        </v-col>
                                        <v-col cols="12" v-else-if="keyHasTextArea(col.key)">
                                            <v-textarea-filled
                                                v-model="
                                                    fieldsChild_[`${getRepeatedKey(col.key, li)}`]
                                                        .displayValue
                                                "
                                                :readonly="isReadonly(col.key)"
                                                hide-details
                                                :bg-color="
                                                    isUserValue(col.key) ? 'blue lighten-5' : '#FFF'
                                                "
                                                :class="{
                                                    'form-field': true,
                                                    'focus-form-field': isImpactedByRule(col.key),
                                                }"
                                                dense
                                                block
                                                @update:model-value="updateSpecManager()"
                                                @click="setFocusedField(col.key)"
                                            />
                                        </v-col>
                                        <v-col cols="12" v-else>
                                            <v-textarea-filled
                                                :maxlength="200"
                                                rows="1"
                                                auto-grow
                                                v-model="
                                                    fieldsChild_[`${getRepeatedKey(col.key, li)}`]
                                                        .displayValue
                                                "
                                                :readonly="isReadonly(col.key)"
                                                :bg-color="
                                                    isUserValue(col.key) ? 'blue lighten-5' : '#FFF'
                                                "
                                                hide-details
                                                :reverse="justifyInputRight(col.key)"
                                                :class="{
                                                    'form-field': true,
                                                    'focus-form-field': isImpactedByRule(col.key),
                                                }"
                                                :label="getKey(`${getRepeatedKey(col.key, li)}`)"
                                                @update:model-value="updateSpecManager()"
                                                @update:focused="setFocused($event, col.key)"
                                                density="compact"
                                                @keydown="preventEnter"
                                            >
                                                <template
                                                    v-slot:append
                                                    v-if="
                                                        rules_[col.key] && rules_[col.key].function
                                                    "
                                                >
                                                    <v-tooltip
                                                        v-if="
                                                            appendIcon(col.key) && rules_[col.key]
                                                        "
                                                        location="bottom"
                                                    >
                                                        <template v-slot:activator="{ props }">
                                                            <v-icon
                                                                class="mt-2"
                                                                v-bind="props"
                                                                @click="
                                                                    openFunctionDialog(
                                                                        rules_[col.key].function,
                                                                        getRepeatedKey(col.key, li),
                                                                        fieldsChild_[
                                                                            `${getRepeatedKey(
                                                                                col.key,
                                                                                li,
                                                                            )}`
                                                                        ].displayValue,
                                                                        li,
                                                                    )
                                                                "
                                                                size="small"
                                                            >
                                                                {{ appendIcon(col.key) }}
                                                            </v-icon>
                                                        </template>
                                                        <span
                                                            v-for="(
                                                                tooltip, ti
                                                            ) of splitFunctionString(
                                                                rules_[col.key].function,
                                                            )"
                                                            :key="ti"
                                                        >
                                                            <template v-if="ti % 2">{{
                                                                tooltip
                                                            }}</template>
                                                            <v-chip
                                                                v-else
                                                                class="mx-1"
                                                                size="small"
                                                            >
                                                                {{ tooltip }}
                                                            </v-chip>
                                                        </span>
                                                    </v-tooltip>
                                                </template>
                                            </v-textarea-filled>
                                        </v-col>
                                    </v-row>
                                </template>
                                <template v-else-if="col.tables">
                                    <TaxFormTable
                                        :tables="col.tables"
                                        :values="values_"
                                        :isLoaded="isLoaded"
                                        :fieldsChild="fieldsChild_"
                                        :rules="rules_"
                                        :sheet="sheet"
                                        :isSent="isSent"
                                        :readonly="readOnly"
                                        :millesimInput="millesim"
                                        @updateSpecManager="updateSpecManager"
                                        @additionnal-page-created="additionnalPageCreated"
                                    >
                                    </TaxFormTable>
                                </template>
                            </div>
                        </div>
                        <div class="d-flex justify-center pt-1 pb-4" v-if="row.link">
                            <v-btn
                                :disabled="isSent || readOnly"
                                rounded
                                elevation="0"
                                size="small"
                                @click="createAdditionalPage(row.link)"
                            >
                                <v-icon>$add</v-icon>
                                <span class="pl-1">Ajouter une page complémentaire</span>
                            </v-btn>
                        </div>
                    </template>
                    <!-- row is not repeat -->
                    <template v-else>
                        <div
                            class="d-flex align-center"
                            v-for="(col, ci) of row.columns"
                            :key="ri + '-' + ci"
                            :style="getStyle(col)"
                        >
                            <!-- address -->
                            <template
                                v-if="
                                    col.component &&
                                    (col.component.includes('address') ||
                                        col.component.includes('financial'))
                                "
                            >
                                <TaxFormAddress
                                    :component="col.component"
                                    :fieldsChild="fieldsChild_"
                                    :subtype="col.component.subtype"
                                    :colKey="col.key"
                                    :isLoaded="isLoaded"
                                    :isSent="isSent"
                                    :readOnly="readOnly || isReadonly(col.key)"
                                    :millesimInput="millesim"
                                    @updateSpecManager="updateSpecManager()"
                                />
                            </template>
                            <!-- formatted text -->
                            <template v-else-if="isFormattedText(col.key)">
                                <v-progress-circular
                                    v-if="!fieldsChild_[col.key]"
                                    indeterminate
                                    color="primary"
                                    size="20"
                                />
                                <TaxFormFormattedText
                                    v-else
                                    v-model="fieldsChild_[`${col.key}`].displayValue"
                                    @updateSpecManager="updateSpecManager()"
                                />
                            </template>
                            <!-- column is title -->
                            <template v-else-if="col.type && col.type === 'title'">
                                {{ col.value }}
                                <v-spacer v-if="col.link" />
                                <v-btn
                                    :disabled="isSent || readOnly"
                                    v-if="col.link"
                                    class="ml-5"
                                    rounded
                                    elevation="0"
                                    size="x-small"
                                    @click="createAdditionalPage(col.link)"
                                >
                                    <v-icon size="x-small">$add</v-icon>
                                    <span class="pl-1">Détail</span>
                                </v-btn>
                            </template>
                            <!-- other -->
                            <template v-else-if="col.key && isLoaded">
                                <v-row no-gutters class="pt-2">
                                    <v-col cols="12" v-if="!fieldsChild_[col.key]">
                                        <v-progress-circular
                                            indeterminate
                                            color="primary"
                                            size="20"
                                        />
                                    </v-col>
                                    <!-- selector -->
                                    <v-col
                                        cols="12"
                                        v-else-if="selectorOfKey(col.key)"
                                        style="overflow: hidden"
                                    >
                                        <!-- checkbox -->
                                        <template v-if="isCheckbox(selectorOfKey(col.key))">
                                            <v-checkbox
                                                :readonly="isReadonly(col.key)"
                                                v-model="fieldsChild_[col.key].displayValue"
                                                true-value="X"
                                                :false-value="''"
                                                hide-details
                                                class="mt-0"
                                                @update:model-value="
                                                    updateSpecManager();
                                                    // as a refresh key but very fast ...
                                                    // for example : 2035A:GF is a reactive value, function of 2035A:GG checkbox value, but is not reactive otherwise
                                                    dialog2 = true;
                                                    dialog2 = false;
                                                    //
                                                "
                                                color="primary"
                                            />
                                        </template>
                                        <!-- other selector -->
                                        <template v-else>
                                            <v-select-filled
                                                :readonly="isReadonly(col.key)"
                                                v-model="fieldsChild_[col.key].displayValue"
                                                :items="
                                                    getSelectorValuesFile(selectorOfKey(col.key))
                                                "
                                                :bg-color="
                                                    isUserValue(col.key) ? 'blue lighten-5' : '#FFF'
                                                "
                                                hide-details
                                                :class="{
                                                    'form-field': true,
                                                    'oss-dark': true,
                                                    'focus-form-field': isImpactedByRule(col.key),
                                                    'text-truncate': true,
                                                }"
                                                block
                                                clearable
                                                @update:focused="onFocus($event, col.key)"
                                                @update:model-value="updateSpecManager()"
                                                @click="setFocusedField(col.key)"
                                                density="compact"
                                                item-title="text"
                                                item-value="value"
                                            />
                                        </template>
                                    </v-col>
                                    <!-- has text area -->
                                    <v-col cols="12" v-else-if="keyHasTextArea(col.key)">
                                        <v-textarea-filled
                                            v-model="fieldsChild_[col.key].displayValue"
                                            :bg-color="
                                                isUserValue(col.key) ? 'blue lighten-5' : '#FFF'
                                            "
                                            hide-details
                                            :class="{
                                                'form-field': true,
                                                'focus-form-field': isImpactedByRule(col.key),
                                            }"
                                            dense
                                            block
                                            @update:model-value="updateSpecManager()"
                                            @click="setFocusedField(col.key)"
                                        />
                                    </v-col>
                                    <!-- percentage -->
                                    <v-col cols="12" v-else-if="isPercentage(col.key)">
                                        <v-text-field-filled
                                            :readonly="isReadonly(col.key)"
                                            v-model="fieldsChild_[col.key].value"
                                            :bg-color="
                                                isUserValue(col.key) ? 'blue lighten-5' : '#FFF'
                                            "
                                            dense
                                            hide-details
                                            :reverse="justifyInputRight(col.key)"
                                            :class="{
                                                'form-field': true,
                                                'oss-dark': true,
                                                'focus-form-field': isImpactedByRule(col.key),
                                            }"
                                            :label="getKey(col.key)"
                                            @update:model-value="updateSpecManager()"
                                            @update:focused="setFocused($event, col.key)"
                                        >
                                        </v-text-field-filled>
                                    </v-col>
                                    <!-- text or number -->
                                    <v-col cols="12" v-else>
                                        <v-text-field-filled
                                            :readonly="isReadonly(col.key)"
                                            v-model="fieldsChild_[col.key].displayValue"
                                            :bg-color="
                                                isUserValue(col.key) ? 'blue lighten-5' : '#FFF'
                                            "
                                            dense
                                            hide-details
                                            :reverse="justifyInputRight(col.key)"
                                            :class="{
                                                'form-field': true,
                                                'focus-form-field': isImpactedByRule(col.key),
                                            }"
                                            :label="getKey(col.key)"
                                            @update:model-value="updateSpecManager()"
                                            @update:focused="setFocused($event, col.key)"
                                        >
                                            <template
                                                v-slot:append
                                                v-if="rules_[col.key] && rules_[col.key].function"
                                            >
                                                <v-tooltip
                                                    bottom
                                                    v-if="appendIcon(col.key) && rules_[col.key]"
                                                >
                                                    <template v-slot:activator="{ props }">
                                                        <v-icon
                                                            class="mt-2"
                                                            v-bind="props"
                                                            @click="
                                                                openFunctionDialog(
                                                                    rules_[col.key].function,
                                                                    col.key,
                                                                    fieldsChild_[col.key]
                                                                        .displayValue,
                                                                )
                                                            "
                                                            size="small"
                                                        >
                                                            {{ appendIcon(col.key) }}
                                                        </v-icon>
                                                    </template>
                                                    <span
                                                        v-for="(tooltip, ti) of splitFunctionString(
                                                            rules_[col.key].function,
                                                        )"
                                                        :key="ti"
                                                    >
                                                        <template v-if="ti % 2">{{
                                                            tooltip
                                                        }}</template>
                                                        <v-chip v-else class="mx-1" size="small">
                                                            {{ tooltip }}
                                                        </v-chip>
                                                    </span>
                                                </v-tooltip>
                                            </template>
                                        </v-text-field-filled>
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-else-if="col.tables">
                                <TaxFormTable
                                    :tables="col.tables"
                                    :values="values_"
                                    :isLoaded="isLoaded"
                                    :fieldsChild="fieldsChild_"
                                    :rules="rules_"
                                    :sheet="sheet"
                                    :isSent="isSent"
                                    :readOnly="readOnly"
                                    :millesimInput="millesim"
                                    @updateSpecManager="updateSpecManager"
                                    @additionnal-page-created="additionnalPageCreated"
                                >
                                </TaxFormTable>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <oss-dialog
            v-model="functionDialog"
            v-if="functionDialog"
            title="Détail du champ sélectionné"
            @close="
                functionDialog = false;
                radicalTab = 'generalLedger';
            "
            @valid="updateResetUserValue()"
            :hide-valid="(isRadicalOnly(keyManualValue) && !enableEdition) || isSent || readOnly"
        >
            <div style="width: 750px">
                <v-tabs v-if="sheet && sheet.bundleBase" v-model="radicalTab" color="primary">
                    <v-tab
                        value="edition"
                        href="#edition"
                        v-if="enableEdition || !isRadicalOnly(keyManualValue)"
                        >Edition</v-tab
                    >
                    <v-tab
                        value="generalLedger"
                        href="#generalLedger"
                        v-if="containsRadical(keyManualValue)"
                        >Comptes de la balance</v-tab
                    >
                    <v-tab value="radicals" href="#radicals" v-if="containsRadical(keyManualValue)"
                        >Fourchettes de comptes</v-tab
                    >
                </v-tabs>
                <v-tabs-window v-model="radicalTab">
                    <v-tabs-window-item value="edition">
                        <v-row no-gutters class="px-5 my-3 d-flex justify-center align-center">
                            <v-col cols="3">
                                <b>Formule :</b>
                            </v-col>
                            <v-col cols="9">
                                {{ functionInDialog }}
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="px-5 my-3 d-flex justify-center align-center">
                            <v-col cols="3">
                                <b>Valeur d'origine :</b>
                            </v-col>
                            <v-col cols="9">
                                {{ getOriginalValue() }}
                                <v-btn
                                    :disabled="isSent || readOnly"
                                    rounded="circle"
                                    elevation="0"
                                    size="x-small"
                                    @click="resetOriginalValue()"
                                    icon="$fa-sync-alt"
                                    class="ml-1"
                                >
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="px-5 my-3 d-flex justify-center align-center">
                            <v-col cols="3">
                                <b>Valeur actuelle :</b>
                            </v-col>
                            <v-col cols="9">
                                {{ getCurrentValue() }}
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="px-5 my-3 d-flex justify-center align-center">
                            <v-col cols="3">
                                <b>Valeur manuelle :</b>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field-filled
                                    :disabled="
                                        (isRADResult && !enableEdition) || isSent || readOnly
                                    "
                                    v-model="userValue"
                                    outlined
                                    hide-details
                                    :label="!isSent && !readOnly && 'Valeur manuelle'"
                                    clearable
                                    autofocus
                                    density="compact"
                                />
                            </v-col>
                            <v-col cols="6" />
                        </v-row>
                    </v-tabs-window-item>
                    <v-tabs-window-item v-if="sheet && sheet.bundleBase" value="generalLedger">
                        <v-col cols="12">
                            <v-row no-gutters class="mb-3">
                                Ce montant de {{ originalValue }} &#x20ac; a été calculé depuis la
                                balance et n'est pas modifiable. Il se décompose comme suit :
                            </v-row>
                            <v-row no-gutters class="mb-1">
                                <v-col cols="2">
                                    <b>Numéro</b>
                                </v-col>
                                <v-col cols="6">
                                    <b>Libellé</b>
                                </v-col>
                                <v-col cols="2" class="text-right">
                                    <b>Débit</b>
                                </v-col>
                                <v-col cols="2" class="text-right">
                                    <b>Crédit</b>
                                </v-col>
                            </v-row>
                            <v-row
                                no-gutters
                                v-for="(acc, index) of getRadicalComposition(functionInDialog)"
                                :key="index"
                                class="my-1"
                            >
                                <v-col cols="12" v-if="acc.balance !== 0 && acc.balance !== -0">
                                    <v-row no-gutters>
                                        <v-col cols="2">
                                            {{ acc.name }}
                                        </v-col>
                                        <v-col cols="6">
                                            {{ acc.description }}
                                        </v-col>
                                        <v-col cols="2" class="text-right">
                                            {{
                                                acc.balance > 0
                                                    ? commaForDot(Math.abs(acc.balance))
                                                    : ""
                                            }}
                                        </v-col>
                                        <v-col cols="2" class="text-right">
                                            {{
                                                acc.balance < 0
                                                    ? commaForDot(Math.abs(acc.balance))
                                                    : ""
                                            }}
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-tabs-window-item>
                    <v-tabs-window-item v-if="sheet && sheet.bundleBase" value="radicals">
                        <v-col cols="12">
                            <v-row no-gutters class="mb-3">
                                Cette cellule est composée des racines de comptes suivantes :
                            </v-row>
                            <v-row
                                no-gutters
                                class="my-1"
                                v-for="(acc, index) of getRadicalList(functionInDialog)"
                                :key="index"
                            >
                                <v-col>
                                    {{
                                        `${acc.account} | ${
                                            acc.debit ? "débit : RAD" + acc.debit : " "
                                        }` + `${acc.credit ? "crédit : RAD" + acc.credit : ""}`
                                    }}
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-tabs-window-item>
                </v-tabs-window>
            </div>
        </oss-dialog>
        <v-dialog v-model="dialog2"></v-dialog>
    </div>
</template>
<script lang="ts">
import { TaxFormBase } from "./TaxFormBase";
import SpecFunction from "../../../../backend/src/common/specs/SpecFunction";
import SpecTernaryOperator from "../../../../backend/src/common/specs/SpecTernaryOperator";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Emit, Watch } from "vue-facing-decorator";
import TaxFormAddress from "./TaxFormAddress.vue";
import TaxFormFormattedText from "./TaxFormFormattedText.vue";

@Component({
    components: {
        TaxFormAddress,
        TaxFormFormattedText,
    },
})
export class TaxFormTable extends TaxFormBase {
    @Prop({ default: null }) tables: any;
    @Prop({ default: false }) enableEdition: boolean;

    dicoKeys = {};

    listFields = [];

    dicoSelectors = {};

    functionDialog = false;

    dialog2 = false;

    functionInDialog = "";

    userValue = "";

    keyManualValue = "";

    indexManualValue = null;

    originalValue = null;

    radicalTab = "generalLedger";

    @Watch("functionDialog")
    resetValues(value, prevValue) {
        if (this.functionDialog === false) {
            this.userValue = "";
            this.originalValue = "";
        }
    }

    get tables_() {
        if (this.tables) {
            return this.tables;
        }
        if (this.sheet?.form?.tables) {
            return this.sheet.form.tables;
        }
        if (this.sheet?.form?.form?.tables) {
            return this.sheet.form.form.tables;
        }
        return null;
    }

    get isRADResult() {
        let rule = this.rules_?.[this.keyManualValue];
        if (!rule) {
            return false;
        }
        if (rule.function && rule.function.includes("[RAD")) {
            return true;
        }
        return false;
    }

    focusKey = null;

    onFocus(e, key) {
        if (e) {
            this.setFocusKey(key);
        } else {
            this.unsetFocusKey(key);
        }
    }

    setFocusKey(key) {
        this.focusKey = key;
    }

    unsetFocusKey(key) {
        if (this.focusKey === key) {
            this.focusKey = null;
        }
    }

    appendIcon(key) {
        if (this.enableEdition) {
            return "$oss-edit";
        } else {
            if (this.isRadicalOnly(key)) {
                return "$oss-eye";
            }
            if (/*!this.isReadonly(key) && */ this.isFunction(key)) {
                return "$oss-edit";
            }
        }
        return "";
    }

    jsonValue(jsonFile) {
        if (jsonFile) {
            return jsonFile;
        }
        return null;
    }

    typeOfKey(columnKey) {
        debugger;
        if (this.values_) {
            if (this.values_?.[columnKey]) {
                return this.values_[columnKey].type;
            }
            // Cas où la key n'a pas de type
        }
        return "";
    }

    keyHasTextArea(columnKey) {
        if (this.values_) {
            if (this.values_?.[columnKey] && this.values_?.[columnKey]?.textarea) {
                return true;
            }
        }
        return false;
    }

    isFunction(field) {
        return !!this.rules_?.[field]?.function;
    }

    isRadical(field) {
        if (this.isFunction(field)) {
            return this.rules_?.[field]?.function?.includes("[RAD")?.includes("[RAD");
        }
        return false;
    }

    isRadicalOnly(field) {
        if (this.isFunction(field)) {
            const regex = /\[((\w|\d|\:|\_|\@)*)\]/g;
            const showFunc = this.rules_?.[field]?.function;
            const matches = showFunc.match(regex);
            if (matches.length) {
                if (matches.every((m) => m.startsWith("[RAD"))) {
                    return true;
                }
            }
            return false;
            // return this.rules_?.[field]?.function?.includes("[RAD")
        }
        return false;
    }

    containsRadical(field) {
        if (this.isFunction(field)) {
            const regex = /\[((\w|\d|\:|\_|\@)*)\]/g;
            const showFunc = this.rules_?.[field]?.function;
            const matches = showFunc.match(regex);
            if (matches.length) {
                if (matches.find((m) => m.startsWith("[RAD"))) {
                    return true;
                }
            }
            return false;
        }
        return false;
    }

    getOriginalValue() {
        const cel =
            this.fieldsChild_[`${this.getRepeatedKey(this.keyManualValue, this.indexManualValue)}`];
        if (cel instanceof SpecFunction) {
            return Math.round(+cel.originalValue);
            // const amount = Math.round(+cel.originalValue)
            // return this.commaForDot(amount)
        }
        if (cel instanceof SpecTernaryOperator) {
            const amount = Math.round(+cel.originalValue);
            return this.commaForDot(amount);
        }
        debugger;
        return 0;
    }

    getCurrentValue() {
        const field =
            this.fieldsChild_[`${this.getRepeatedKey(this.keyManualValue, this.indexManualValue)}`];
        if (field) {
            return field.displayValue;
            // const amount = Math.round(+field.displayValue)
            // return this.commaForDot(amount)
        }
        debugger;
        return 0;
    }

    commaForDot(amount) {
        return amount !== null && amount !== undefined ? amount.toString().replace(".", ",") : "";
    }

    getFunctionText(field) {
        if (this.isFunction(field)) {
            return this.rules_?.[field]?.function;
        }
        return "";
    }

    getKey(field) {
        if (this.fieldsChild_?.[field].getKey) {
            return this.fieldsChild_?.[field]?.getKey() || "OK";
        }
        debugger;
        console.error("getKey = ", field);
        return "OK";
    }

    openFunctionDialog(functionField, key, originalValue, index = 1) {
        if (functionField) {
            this.functionDialog = true;
            this.keyManualValue = key;
            this.indexManualValue = index;
            this.functionInDialog = functionField;
            this.originalValue = originalValue;
            if (this.enableEdition || !this.isRadicalOnly(this.keyManualValue)) {
                this.radicalTab = "edition";
            } else {
                this.radicalTab = "generalLedger";
            }
        }
    }

    updateResetUserValue() {
        const field = this.fieldsChild_[this.keyManualValue];
        if (field) {
            if (this.userValue) {
                field.forceUserValue(this.userValue);
            } else {
                field.forceUserValue(null);
            }
            if (this.sheet?.bundleBase) {
                this.sheet.bundleBase.update();
            }
        } else {
            debugger;
        }

        this.userValue = "";
        this.indexManualValue = null;
        this.originalValue = null;
        this.functionDialog = false;

        this.updateSpecManager();
    }

    resetOriginalValue() {
        const field = this.fieldsChild_[this.keyManualValue];
        if (field) {
            field.resetOriginalValue();
        } else {
            debugger;
        }

        this.userValue = "";
        this.indexManualValue = null;
        this.originalValue = null;
        this.functionDialog = false;

        this.updateSpecManager();
    }

    getStyle(col) {
        let style = { ...col.style };
        if (style?.["background-color"] === "silver") {
            style["background-color"] = "lightgrey";
        }
        return {
            width: col.width + "%",
            ...style,
            float: "left",
            "box-shadow": `2px 0 0 0 #888,
                0 2px 0 0 #888,
                2px 2px 0 0 #888,   /* Just to fix the corner */
                2px 0 0 0 #888 inset,
                0 2px 0 0 #888 inset`,
            padding: col?.component?.includes("address") || col.tables ? "none" : "0px 5px",
            "min-height": "20px",
            "justify-content": style?.["text-align"] || "start",
        };
    }

    splitFunctionString(functionString) {
        if (!functionString) {
            debugger;
        }
        const functionArray = functionString.split(/\[|\]/g);
        return functionArray.filter((item) => item !== "");
    }

    isNumberNotQuantityInJson(columnKey) {
        if (this.values_) {
            if (this.values_?.[columnKey]?.type === "number") {
                return true;
            }
        }
        return false;
    }

    @Emit("additionnal-page-created")
    async createAdditionalPage(cerfaNumber: string) {
        await this.sheet.createAdditionalPage(cerfaNumber);
        return cerfaNumber;
    }

    @Emit("additionnal-page-created")
    additionnalPageCreated(cerfaNumber: string) {
        return cerfaNumber;
    }
   
    preventEnter(event) {
    if (event.key === "Enter") {
        event.preventDefault(); 
    }
}    
}

export default toNative(TaxFormTable);
</script>

